<cap-content-header>
  <cap-title>
    {{ "alte-grundbuchmeldung.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<ul [activeId]="'searchStandard'" class="nav-tabs" justify="start" ngbNav>
  <li [ngbNavItem]="'searchStandard'">
    <a ngbNavLink>{{ "Standardsuche" | translate }}</a>
    <ng-template id="suche" ngbNavContent></ng-template>
  </li>
</ul>

<form (ngSubmit)="onSubmit()" [meta]="searchRequest && searchRequest.grundstueckNummerSearchRequest" #form="ngForm" class="mt-2">
  <div class="row mb-0">
    <cap-grundstueck-nummer
      (ngModelChange)="searchRequest && (searchRequest.grundstueckNummerSearchRequest = $event)"
      [mitRegion]="false"
      [ngModel]="searchRequest && searchRequest.grundstueckNummerSearchRequest"
      [nurGueltige]="false"
      [searchMode]="searchMode"
      class="col-md-12"
      heading="BeteiligteGrundstuecke"
      name="grundstueckNummerSearchRequest"></cap-grundstueck-nummer>
  </div>
  <div>
    <p class="mt-1"><i class="fas fa-info-circle"></i> {{ "alte-grunbbuchmeldungen.datenbestandBisUndMit" | translate }}</p>
  </div>

  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
